export default {
  data() {
    return {
      validationRules: {
        required: value => !!value || 'Required.',
        email: (value) => {
          // Pattern is from vuetify documentation https://v15.vuetifyjs.com/en/components/text-fields at Validation
          // eslint-disable-next-line max-len
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return !value || pattern.test(value) || 'Invalid e-mail.';
        },
        date: (format = 'DD/MM/YY') => (value) => {
          if (!value) {
            return true;
          }
          if (value.length !== 8) {
            return `Must be ${format.toLowerCase()} format`;
          }
          return this.$moment(value, format).isValid() || 'Invalid Date';
        },
        max(max) {
          return value => !value || value.length <= max || 'Max length exceeded';
        },
        size(min, max) {
          return (value) => {
            const parsedVal = parseFloat(value);
            if (Number.isNaN(parsedVal)) {
              return 'Invalid Number';
            }
            return (parsedVal >= min && parsedVal <= max) || `Must be between ${min} and ${max}`;
          };
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/validationRules.js